import React from 'react'
import PropTypes from 'prop-types'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

class DefaultButton extends React.Component {
  render() {
    const { icon, onClick, id, marginless = false } = this.props

    const size = this.props.mediaQuery({
      tablet: 30,
      phone: 24,
    })

    return (
      <button
        className={`${
          marginless ? 'pv0 ph0' : 'pv3 ph5'
        } pointer flex-none  pv4-ns pv3-l mh4-ns ml3-l bn bg-transparent`}
        onClick={onClick}
        data-testid={id}
        id={id}
      >
        {icon !== null ? (
          <Icon type={icon} size={size} color="#4a4a4a" />
        ) : (
          <div style={{ width: size }} />
        )}
      </button>
    )
  }
}

DefaultButton.propTypes = {
  icon: PropTypes.string,
  marginless: PropTypes.bool,
  onClick: PropTypes.func,
  mediaQuery: PropTypes.func,
  id: PropTypes.string,
}

DefaultButton.defaultProps = {
  onClick: () => {},
  icon: null,
  id: undefined,
}

export default withMediaQuery(DefaultButton)
